import { useMemo } from "react";
import { Select } from "../controls";
import { useCategories } from "../hooks/queries";

const SpecialityDropdown = ({ name, value, onChange }: any) => {
  const { data = [] } = useCategories();
  const cats = useMemo(
    () => data.map((k: any) => ({ label: k?.name, value: k?.name })),
    [data]
  );

  return (
    <Select
      name={name}
      title="Choose..."
      options={cats}
      showFirstOption={true}
      value={value}
      onChange={onChange}
    />
  );
};

export default SpecialityDropdown;
